import { render, staticRenderFns } from "./unmatch-logs.vue?vue&type=template&id=620cffe6&"
import script from "./unmatch-logs.vue?vue&type=script&lang=js&"
export * from "./unmatch-logs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports